module.exports = __webpack_public_path__ + "img/people-cargo-rate.33ec6e5.png";